/**
 * Module dependencies.
 */

import React from 'react';
import { Card } from '@tremor/react';
import { Title } from 'app/components/atoms/title/title';
import { useTranslation } from 'react-i18next';

/**
 * Export `SupportOverview` component.
 */

export function SupportOverview(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <Card>
      <Title>{translate('support.overview.title')}</Title>
    </Card>
  );
}
